/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEmploymentsForMerchantRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {GetEmploymentsForMerchantResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const getEmploymentsForMerchant = (request: GetEmploymentsForMerchantRequest, options?: CashRequestOptions) => post<GetEmploymentsForMerchantRequest, GetEmploymentsForMerchantResponse>("/2.0/cash/get-employments-for-merchant", request, {...options, rejectOnError: true })